<script lang="ts" setup>
interface Props {
  icon?: string
}

defineProps<Props>()
</script>

<template>
  <div class="flex items-center gap-1">
    <CommonIcon v-if="icon" :name="icon" size="32" />
    <slot />
  </div>
</template>
